/*
 * ceq-events-past.js
 * Scope: Blog-Artikel mit Event-Tabellen (.ceq-product-comparison__row).
 * Geladen in sections/article-education.liquid + sections/main-article.liquid,
 * jeweils nur wenn der Artikel diese Tabellen enthaelt.
 *
 * Zweck: Vergangene Events aus der oeffentlichen Liste ausblenden. Liest pro
 * Tabellenzeile das Datum aus data-label (bei Zeitspannen das Enddatum),
 * vergleicht mit heute und setzt bei vorbei die Klasse .ceq-event--past
 * (CSS blendet die Zeile per display:none aus). Zeilen ohne echtes Datum
 * (z. B. "tbd 2026", "Laufend", "Ongoing") werden nie als vorbei behandelt
 * und bleiben als Teaser stehen.
 *
 * Redaktion / Aufraeumen: Artikel-URL mit ?show-past aufrufen. Dann werden die
 * vergangenen Zeilen wieder eingeblendet und rot mit "Vergangen – loeschen"
 * markiert — so sieht man auf einen Blick, welche Zeilen beim naechsten
 * Editieren des body_html geloescht werden koennen. Bis dahin sind sie fuer
 * Besucher einfach unsichtbar.
 */
(function () {
  'use strict';

  // Staff-Sichtmodus: vergangene Events sichtbar + als "loeschen" markiert.
  var REVEAL = /[?&]show-past(?:=|&|$)/.test(window.location.search);

  // Letztes vollstaendiges DD.MM.YYYY im Label = Enddatum des Events.
  function parseEndDate(label) {
    if (!label) return null;
    var re = /(\d{1,2})\.(\d{1,2})\.(\d{4})/g;
    var m, last = null;
    while ((m = re.exec(label)) !== null) {
      last = m;
    }
    if (!last) return null;
    // Ende des Event-Tages: erst am Folgetag gilt das Event als vorbei.
    return new Date(
      parseInt(last[3], 10),
      parseInt(last[2], 10) - 1,
      parseInt(last[1], 10),
      23, 59, 59, 999
    );
  }

  function deleteHint() {
    var lang = (document.documentElement.getAttribute('lang') || 'de').toLowerCase();
    return lang.indexOf('en') === 0 ? 'Past – delete' : 'Vergangen – löschen';
  }

  function run() {
    var rows = document.querySelectorAll('.ceq-product-comparison__row');
    if (!rows.length) return;

    var now = new Date();
    if (REVEAL) {
      document.documentElement.classList.add('ceq-events-reveal-past');
    }
    var text = deleteHint();

    Array.prototype.forEach.call(rows, function (row) {
      var end = parseEndDate(row.getAttribute('data-label'));
      if (!end || end >= now) return;

      row.classList.add('ceq-event--past');

      // Loesch-Marker nur im Sichtmodus — im Normalfall ist die Zeile ohnehin
      // ausgeblendet, das Badge braucht dann niemand.
      if (!REVEAL) return;

      var cell = row.querySelector('[data-column="Event"]') ||
                 row.querySelector('.ceq-product-comparison__cell');
      if (cell && !cell.querySelector('.ceq-event__past-badge')) {
        var badge = document.createElement('span');
        badge.className = 'ceq-event__past-badge';
        badge.textContent = text;
        cell.appendChild(badge);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
